import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import OrderCreator from 'containers/Orders/OrderCreator/OrderCreator';
import OrderDetails from 'containers/Orders/OrderDetails/OrderDetails';
import OrdersDashboard from 'containers/Orders/OrdersDashboard';
function Orders() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, element: React.createElement(OrdersDashboard, null) }),
        React.createElement(Route, { path: "creator/:orderId/*", element: React.createElement(React.Fragment, null,
                React.createElement(OrdersDashboard, null),
                React.createElement(OrderCreator, null)) }),
        React.createElement(Route, { path: ":orderId/*", element: React.createElement(OrderDetails, null) })));
}
export default memo(Orders);
